export enum DataRegions {
  US = "US",
  EU = "Europe",
}

export const SIGNUP_QUERY_PARAM = "grmksignup";
